import { bindActionCreators } from 'redux';
import Jaws from 'oms-jaws';

import * as Actions from 'actions/jaws';
import { BASE_URL, SECURE_BASE_URL } from 'constants/Jaws';
import { useSelector } from 'react-redux';
import { selectIsUserLoggedIn } from '../state/user/selectors';

const MAX_RECONNECT_ATTEMPTS = 5;
let reconnectTimer = null;

function reconnect(jaws, reconnectAttempts = 0) {
  let sleep;
  if (reconnectAttempts <= MAX_RECONNECT_ATTEMPTS) {
    sleep = reconnectAttempts * 1000;
  } else {
    sleep = 0;
    jaws.useWebSockets = false;
  }

  clearTimeout(reconnectTimer);
  reconnectTimer = setTimeout(() => {
    if (jaws.state === 'disconnected') {
      jaws.reconnect();
    }
  }, sleep);
}

export default function useConfigureJaws(dispatch, useWebSockets) {
  const isLoggedIn = useSelector(selectIsUserLoggedIn);
  const jaws = new Jaws(isLoggedIn ? SECURE_BASE_URL : BASE_URL, useWebSockets);
  const actions = bindActionCreators(Actions, dispatch);

  actions.setInstance(jaws);

  let reconnectAttempts = 0;
  let pingTimestamp = null;
  let pingTimeout = null;
  let pingInterval = false;

  // TODO Helge fix these so reconnect works
  let inactive = null;
  let connectionClosedEventSent = null;

  jaws.onOpen = () => {
    reconnectAttempts = 0;
    actions.connectionEstablished();

    if (jaws.useWebSockets && !pingInterval) {
      pingInterval = setInterval(() => {
        pingTimeout = setTimeout(() => {
          clearInterval(pingInterval);
          pingInterval = null;
          jaws.disconnect();
          reconnect(jaws, ++reconnectAttempts);
        }, 1000);
        pingTimestamp = Date.now();
        jaws.ping();
      }, 30000);
    }
  };

  jaws.bind('pong', () => {
    const delay = Date.now() - pingTimestamp;
    if (delay > 1000) {
      clearInterval(pingInterval);
      pingInterval = null;
      jaws.disconnect();
      reconnect(jaws, ++reconnectAttempts);
    }
    if (pingTimeout) {
      clearTimeout(pingTimeout);
    }
  });

  jaws.bind('connection_closed', event => {
    if (event.code === 4503) {
      jaws.useWebSockets = false;
      reconnect(jaws, ++reconnectAttempts);
    }

    if (event.code === 1001 || event.code === 1006) {
      if (!connectionClosedEventSent) {
        actions.connectionClosed();
      }
      if (!inactive) {
        reconnect(jaws, ++reconnectAttempts);
      }
    }
  });

  return jaws;
}
